// src/pages/HomePage/TileContainer/filters/filtersState.ts
import { atom, AtomEffect, RecoilState } from 'recoil';
import { FILTERS_KEYS, SORT_KEYS, DISTANCE_RANGE_MAX } from '../../../../components/FilterAndSort/constants/constants';

export interface FiltersState {
  filters?: FILTERS_KEYS[];
  sortBy: SORT_KEYS | undefined;
  // sizeRange: number[];
  distanceRange: number;
  selectedArea: string | null;
}

const DEFAULT_FILTERS: FiltersState = {
  sortBy: undefined,
  // sizeRange: [SIZE_RANGE.MIN, SIZE_RANGE.MAX],
  distanceRange: DISTANCE_RANGE_MAX,
  selectedArea: null,
};

const STORAGE_KEY = 'filtersState';
const ATOM_KEY = 'filtersState';

const clientPersistEffect: AtomEffect<FiltersState> = ({ setSelf, onSet, trigger }) => {
  if (typeof window === 'undefined') return;

  if (trigger === 'get') {
    try {
      const stored = sessionStorage.getItem(STORAGE_KEY);
      if (stored) {
        const parsed = JSON.parse(stored);
        // selectedArea is URL-driven; never restore it from storage.
        setSelf({ ...DEFAULT_FILTERS, ...parsed, selectedArea: null });
      }
    } catch {
      // Ignore parse errors
    }
  }

  onSet((newValue, _, isReset) => {
    try {
      if (isReset) {
        sessionStorage.removeItem(STORAGE_KEY);
      } else {
        const { selectedArea: _, ...rest } = newValue;
        sessionStorage.setItem(STORAGE_KEY, JSON.stringify(rest));
      }
    } catch {
      // Ignore storage errors
    }
  });
};

const atomCache: Map<string, RecoilState<any>> = 
  typeof globalThis !== 'undefined' 
    ? ((globalThis as any).__RECOIL_ATOM_CACHE__ ??= new Map())
    : new Map();

const getOrCreateAtom = <T>(
  key: string,
  config: { default: T; effects_UNSTABLE?: AtomEffect<T>[] }
): RecoilState<T> => {
  if (!atomCache.has(key)) {
    atomCache.set(key, atom<T>({ key, ...config }));
  }
  return atomCache.get(key)!;
};

export const filtersState = getOrCreateAtom<FiltersState>(ATOM_KEY, {
  default: DEFAULT_FILTERS,
  effects_UNSTABLE: [clientPersistEffect],
});

